import React from 'react';
import BaseMixin from '../common/base-mixin.js';
import ElementaryMixin from '../common/elementary-mixin.js';
import Error from '../bricks/error.js';

import './not-found-tag.less';

export const NotFoundTag = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.NotFoundTag',
    defaults: {
      body: 'Tag not found: '
    },
    classNames: {
      main: 'uu5-bricks-not-found-tag'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    tagName: React.PropTypes.string
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      tagName: null
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    let value = this.getDefault().body;
    this.props.tagName && (value += ' ' + this.props.tagName);

    return (
      <Error {...this.getMainPropsToPass()}>
        {value}
      </Error>
    );
  }
  //@@viewOff:render
});

export default NotFoundTag;



// WEBPACK FOOTER //
// ./bricks/not-found-tag.js